import moment from 'moment';

const dateSort = (rowA, rowB, columnID, desc) => {
  const dateA = moment(rowA.values[columnID].slice(0, -4), 'DD-MM-YY HH:mm');
  const dateB = moment(rowB.values[columnID].slice(0, -4), 'DD-MM-YY HH:mm');
  let order = 0;
  if (!dateA.isSame(dateB)) {
    if (desc) {
      order = dateA.isBefore(dateB) ? -1 : 1;
    } else {
      order = dateA.isAfter(dateB) ? 1 : -1;
    }
  }
  return order;
};

const altDateSort = (rowA, rowB, columnID, desc) => {
  const dateA = moment(rowA.values[columnID], 'DD-MM-YYYY');
  const dateB = moment(rowB.values[columnID], 'DD-MM-YYYY');
  let order = 0;
  if (!dateA.isSame(dateB)) {
    if (desc) {
      order = dateA.isBefore(dateB) ? -1 : 1;
    } else {
      order = dateA.isAfter(dateB) ? 1 : -1;
    }
  }
  return order;
};

const mbSizeSort = (rowA, rowB, columnID, desc) => {
  const sizeA = parseFloat(rowA.values[columnID].slice(0, -3));
  const sizeB = parseFloat(rowB.values[columnID].slice(0, -3));
  let order = 0;
  if (sizeA !== sizeB) {
    if (desc) {
      order = sizeA < sizeB ? -1 : 1;
    } else {
      order = sizeA > sizeB ? 1 : -1;
    }
  }
  return order;
};

const numberSort = (rowA, rowB, columnID, desc) => {
  const sizeA = parseInt(rowA.values[columnID].replace(/\D/g, ''), 10);
  const sizeB = parseInt(rowB.values[columnID].replace(/\D/g, ''), 10);
  let order = 0;

  if (sizeA !== sizeB) {
    if (desc) {
      order = sizeA < sizeB ? -1 : 1;
    } else {
      order = sizeA > sizeB ? 1 : -1;
    }
  }
  return order;
};

const durationSort = (rowA, rowB, columnID, desc) => {
  const timesArrayA = rowA.values.duration.split(':');
  const timesArrayB = rowB.values.duration.split(':');
  const durationA = moment
    .duration({
      hours: parseInt(timesArrayA[0], 0),
      minutes: parseInt(timesArrayA[1], 0),
      seconds: parseInt(timesArrayA[2], 0),
    })
    .asMilliseconds();
  const durationB = moment
    .duration({
      hours: parseInt(timesArrayB[0], 0),
      minutes: parseInt(timesArrayB[1], 0),
      seconds: parseInt(timesArrayB[2], 0),
    })
    .asMilliseconds();
  let order = 0;
  if (durationA !== durationB) {
    if (desc) {
      order = durationA - durationB <= 0 ? -1 : 1;
    } else {
      order = durationB - durationA <= 0 ? 1 : -1;
    }
  }
  return order;
};

const formatPhoneNumbersCallsHistory = phoneNumber => {
  const num =
    typeof phoneNumber === 'number' ? toString(phoneNumber) : phoneNumber;
  return `+56 9 ${num.substr(num.length - 8)}`;
};

export {
  dateSort,
  durationSort,
  altDateSort,
  mbSizeSort,
  numberSort,
  formatPhoneNumbersCallsHistory,
};
